
<app-message-box  style="text-align: center;"
          [messageType]="MessageBoxType.ERROR"
          title="Errore {{errorItem.code}} {{errorItem.title}}"
          [content]="errorItem.message"
          [redirectUri]="redirectUri"   
          [autoRedirectMilliseconds]="5000"  
          >
</app-message-box>